import RouterPage from './pages/RouterPage';
import * as React from 'react'

function App() {
  return (
      <div className="App">
        <RouterPage />
      </div>
    );
}

export default App;